import React, { Component } from 'react'
import { domains } from '../../lib/config'

export default class CpuTrainingResources extends Component {
  render() {
    const cdnBase = `${domains.CDN_DOMAIN}/assets/pdfs/cpu/docs`

    return (
      <div>
        <h4>Child Protection Training Resources</h4>
        <h6>Module 1</h6>
        <div className="rule-header" />
        <h5>Resources for Principals and Program Coordinators</h5>
        <p>
          <a
            href={`${cdnBase}/Module1/child-protection-action-plan.pdf`}
            target="_blank"
          >
            Child Protection Strategy Action Plan
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/child-safety-lessons.pdf`}
            target="_blank"
          >
            Personal Safety Lessons for Children
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/communicate-protection-plan.pdf`}
            target="_blank"
          >
            Communicating Your Child Protection Strategy
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a href={`${cdnBase}/Module1/cp-policies-assess.pdf`} target="_blank">
            Child Protection Policies and Procedures Assessment
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a href={`${cdnBase}/Module1/cp-strategy-audit.pdf`} target="_blank">
            Child Protection Strategy Baseline Audit
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/cp-strategy-maintenance.pdf`}
            target="_blank"
          >
            Child Protection Strategy Maintenance Tool
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/create-protection-team.pdf`}
            target="_blank"
          >
            Creating a Child Protection Team
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/family-engagement-cpu.pdf`}
            target="_blank"
          >
            Family Education and Engagement
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/keys-of-adult-training.pdf`}
            target="_blank"
          >
            Key Elements of Adult Training
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/leader-vers-sex-misconduct.pdf`}
            target="_blank"
          >
            Fact Sheet on Staff Sexual Misconduct with Children, Leader Version
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/partner-with-agencies.pdf`}
            target="_blank"
          >
            Partnering with Local Agencies
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/reporting-procedures.pdf`}
            target="_blank"
          >
            Reporting Procedures
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a href={`${cdnBase}/Module1/safe-env-policy.pdf`} target="_blank">
            Safe Environment Policy
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/screen-hire-procedures.pdf`}
            target="_blank"
          >
            Screening and Hiring Procedures
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a href={`${cdnBase}/Module1/staff-conduct-code.pdf`} target="_blank">
            Staff Code of Conduct
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module1/staff-conduct-observ.pdf`}
            target="_blank"
          >
            Staff Code of Conduct Observation Tool
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <br />
        <h6>Module 2</h6>
        <div className="rule-header" />
        <h5>Resources for All Staff</h5>
        <p>
          <a href={`${cdnBase}/Module2/abuse-indicators.pdf`} target="_blank">
            Indicators of Abuse or Neglect
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module2/el-child-support-plan.pdf`}
            target="_blank"
          >
            Child Support Plan, Early Learning
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module2/el-family-support-plan.pdf`}
            target="_blank"
          >
            Family Support Plan
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module2/responding-to-disclosure.pdf`}
            target="_blank"
          >
            Responding to Disclosure
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module2/staff-vers-sex-misconduct.pdf`}
            target="_blank"
          >
            Fact Sheet on Staff Sexual Misconduct with Children, Staff Version
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module2/student-support-plan.pdf`}
            target="_blank"
          >
            Student Support Plan, Kindergarten&ndash;Grade 5
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module2/mod-2-staff-training-guide.pdf`}
            target="_blank"
          >
            Guide to Module 2 Staff Trainings
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <br />
        <h6>Module 3</h6>
        <div className="rule-header" />
        <h5>Resources for Staff Teaching the Lessons</h5>
        <p>
          <a
            href={`${cdnBase}/Module3/el-training-plan-notes.pdf`}
            target="_blank"
          >
            Online Training Planning Notes, Early Learning
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/training-plan-notes.pdf`}
            target="_blank"
          >
            Online Training Planning Notes, Kindergarten&ndash;Grade 3
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/g4-g5-planning-notes.pdf`}
            target="_blank"
          >
            Online Training Planning Notes, Grades 4&ndash;5
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <br />
        <br />
        <style jsx>
          {`
            h4 {
              font-size: 2rem;
              color: #f5961f;
              padding: 20px 0 5px 0;
            }

            h5 {
              font-weight: 100;
            }

            .rule-header {
              margin-bottom: 15px;
              width: 100%;
              height: 1px;
              overflow: hidden;
              margin-top: 0px;
              background-color: #ddd;
            }
          `}
        </style>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/static-training/CpuTrainingResource.js